export type RolesPageState = {
  isOpenRoleDeleteModal: boolean;
};

export const rolesPageInitialState: RolesPageState = {
  isOpenRoleDeleteModal: false,
};
